import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Container, Col } from "react-bootstrap";
import {
  Form,
  Field,
  FormElement,
  FormRenderProps,
  FieldWrapper,
} from "@progress/kendo-react-form";
import { requiredValidator } from "../utils/validators";
import { FormInput } from "../components/FormComponents";
import "../styles/lm-theme/css/login.css";
import { useNotification } from "../contexts/NotificationContext";
import { useProjectContext } from "../contexts/ProjectContext";
import { useLoadingPanel } from "../contexts/LoadingContext";

function Login() {
  const notifications = useNotification();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const projectContext = useProjectContext();
  var loadingPanel = useLoadingPanel();

  const HandleLogin = async () => {
    loadingPanel.show("#root");
  
    try {
      await login(username, password, false).then((res: any) => {
        if (res) {
          projectContext.loadProjects().then((res: any) => {
            if (res?.length > 0) {
              window.location.href = `${process.env.REACT_APP_DEPLOY_PATH}/dashboard`;
            }
          });
        }
      });
    } catch (error) {
      loadingPanel.hide();
      notifications.showNotification("Login error:" + error, "error");
    } finally {
      loadingPanel.hide();
    }
  };

  return (
    <div className="anonymous">
      <Container>
        <div className="center-screen">
          <section id="logoPart">
            <img src="logo192.png" alt="logo" />
          </section>
          <Col xs={3}>
            <Form
              onSubmit={HandleLogin}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement>
                  <fieldset className={"k-form-fieldset"}>
                    <legend className={"k-form-legend"}></legend>
                    <FieldWrapper>
                      <div className="k-form-field-wrap">
                        <Field
                          name={"username"}
                          component={FormInput}
                          labelClassName={"k-form-label"}
                          label={"Username"}
                          validator={requiredValidator}
                          onChange={(e) => setUsername(e.target.value)}
                        />
                      </div>
                    </FieldWrapper>
                    <FieldWrapper>
                      <div className="k-form-field-wrap">
                        <Field
                          name={"password"}
                          component={FormInput}
                          type={"password"}
                          labelClassName={"k-form-label"}
                          label={"Password"}
                          validator={requiredValidator}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                    </FieldWrapper>
                  </fieldset>
                  <div className="k-form-buttons">
                    <button
                      type={"submit"}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base button-wide"
                      disabled={!formRenderProps.allowSubmit}
                    >
                      Login
                    </button>
                  </div>
                </FormElement>
              )}
            />
          </Col>
        </div>
      </Container>
    </div>
  );
}

export default Login;
